"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var environments_1 = require("./environments");

var modules_1 = require("./modules");

var Sdk_1 = require("./Sdk");
/**
 * creates sdk
 * @param env
 */


function createSdk(env) {
  var environment = null;

  if (env instanceof modules_1.Environment) {
    environment = env;
  } else {
    environment = environments_1.getSdkEnvironment(env);
  }

  return new Sdk_1.Sdk(environment);
}

exports.createSdk = createSdk;